import type { ExploreContentItemContentOneOfThreesevenBasicInfoAllOf } from './exploreContentItemContentOneOfThreesevenBasicInfoAllOf';
import type { ExploreContentItemContentOneOfThreesevenBasicInfoAllOfTwo } from './exploreContentItemContentOneOfThreesevenBasicInfoAllOfTwo';

export type ExploreContentItemContentOneOfThreesevenBasicInfo = ExploreContentItemContentOneOfThreesevenBasicInfoAllOf & ExploreContentItemContentOneOfThreesevenBasicInfoAllOfTwo;
